import styled from 'styled-components';
import { border } from 'styled-system';
import { Pin, AnimatedLoadingColorful2 } from '@magalu/stereo-ui-icons';
import { color, getPaletteColor, themeGet } from '@magalu/stereo-ui-styles';
import Flex from '../../atoms/Flex';
import Text from '../../atoms/Text';
export const Container = styled(Flex).attrs(props => Object.assign({
  bg: 'background.base',
  borderRadius: 'medium'
}, props))`
  position: relative;
  padding: 16px 12px;
  align-items: center;
  cursor: pointer;

  ${border}
  ${color}
`;
export const Disabled = styled(Flex).attrs(props => Object.assign({
  bg: 'background.base',
  borderRadius: 'medium',
  zIndex: 4
}, props))`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.7;
  display: flex;
  justify-content: center;
  align-items: center;

  ${border}
  ${color}
`;
export const LoadingIcon = styled(AnimatedLoadingColorful2).attrs({
  width: 24,
  height: 24
})``;
export const PinIcon = styled(Pin)`
  margin-right: 12px;
  flex-grow: 0;
  width: 18px;
  height: 18px;
  ${color}
`;
export const Label = styled(Text)`
  flex-grow: 1;
  font-size: ${props => themeGet('fontSizes.1')(props)}px;
`;
export const ChangeLink = styled(Text)`
  flex-grow: 0;
  font-size: ${props => themeGet('fontSizes.1')(props)}px;
  color: ${props => getPaletteColor('primary.base')(props)};
`;